import React from 'react';
import { TableCell, TableRow } from '@mui/material';

const Definition = ({ id, value }) => {
  return (
    <TableRow>
      <TableCell>
        <span
          style={{
            fontSize: 13,
            fontWeight: 600,
          }}
        >
          {id}
        </span>
      </TableCell>
      <TableCell align="right">
        <span
          style={{
            fontSize: 13,
          }}
        >
          {value}
        </span>
      </TableCell>
    </TableRow>
  );
};

export default Definition;
